import { render, staticRenderFns } from "./submitRegistration.vue?vue&type=template&id=0e60e016&scoped=true"
import script from "./submitRegistration.vue?vue&type=script&lang=js"
export * from "./submitRegistration.vue?vue&type=script&lang=js"
import style0 from "./submitRegistration.vue?vue&type=style&index=0&id=0e60e016&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e60e016",
  null
  
)

export default component.exports